import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

/**
 * Separate RTK Query instance for PUBLIC (unauthenticated) endpoints — e.g. the
 * installation feedback survey shared over WhatsApp.
 *
 * Unlike the main `api` (src/api/index.ts), this one deliberately:
 *  - does NOT attach an Auth-Token or inject `user_id`, and
 *  - does NOT run the 401/403 refresh-token + hard-redirect-to-/auth flow,
 * so an unauthenticated visitor stays on the page instead of being bounced to login.
 *
 * Endpoints inject into this instance via `publicApi.injectEndpoints(...)`.
 */
const getV3BaseUrl = (baseUrl: string): string => {
    if (!baseUrl) return baseUrl
    return baseUrl.replace(/\/v2\//g, "/v3/").replace(/\/v2$/g, "/v3")
}

const publicBaseQuery = fetchBaseQuery({
    baseUrl: getV3BaseUrl(process.env.REACT_APP_BASE_URL || ""),
    paramsSerializer: (params: Record<string, any>) =>
        Object.entries(Object.assign({}, params))
            .map(([key, value]) => `${key}=${value}`)
            .join("&"),
})

export const publicApi = createApi({
    reducerPath: "publicApi",
    baseQuery: publicBaseQuery,
    endpoints: () => ({}),
})
